<div class="column" [ngClass]="{'active': isFocused, 'accepted': isAccepted,
    'error': isError,'error-bcg': isError && isEmpty, 'no_sufix': sufix==''}">
    <div class="row" [class.small]="small">
        <input #input (keydown)="arrowStep($event)" [formControl]="val" pattern="{{pattern}}" inputmode="numeric" (focus)="onFocus($event)" (blur)="onBlur()" (change)="isInputEmpty(model);
            modelChange.emit(model)" [min]="min" [max]="max">
        <span class="sufix">{{getValue()}}<span class="suf">{{sufix}}</span></span>
    </div>
</div>